export default function reducer(
  state = {
    menuOpen: false,
    projectScrolled: false,
    template: null,
    projectHeight: 0,
    homepageIntro: null,
    ready: false,
    currentPath: null,
    preloading: false,
    projectClicked: false, // for video autoplay interaction
  },
  action
) {
  switch (action.type) {
    case 'PROJECT_CLICKED': {
      return {
        ...state,
        projectClicked: true,
      };
    }

    case 'DATA_LOADING': {
      return {
        ...state,
        preloading: true,
      };
    }

    case 'DATA_LOADED': {
      return {
        ...state,
        preloading: false,
      };
    }

    case 'SITE_READY': {
      return {
        ...state,
        ready: true,
      };
    }

    case 'UPDATING_PATH': {
      return {
        ...state,
        currentPath: action.payload,
      };
    }

    case 'UPDATE_INTRO': {
      return {
        ...state,
        homepageIntro: action.payload,
      };
    }

    case 'NAV_OPEN': {
      return {
        ...state,
        menuOpen: true,
      };
    }
    case 'NAV_CLOSED': {
      return {
        ...state,
        menuOpen: false,
      };
    }
    case 'PROJECT_SCROLLED': {
      return {
        ...state,
        projectScrolled: true,
      };
    }
    case 'PROJECT_UNSCROLLED': {
      return {
        ...state,
        projectScrolled: false,
      };
    }
    case 'SETTING_TEMPLATE': {
      return {
        ...state,
        template: action.payload,
      };
    }
    case 'SETTING_PROJECT_HEIGHT': {
      return {
        ...state,
        projectHeight: action.payload,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/redux/reducers/UI.js